<template lang="pug">
	.stylizer--detail.flex-col.space-large.full-width
		Loader(v-if="isLoading", :text="$tCaption('Loading', '@actions') + '..'", :fullscreen="true")
		template(v-if="stylizerBO")
			.flex-col.space-medium
				.flex-row.space.align-center
					.flex-col.flex-2
						.font-small.upper.grey {{$tCaption('Name')}}
						DxTextBox(:value.sync="stylizerBO.Name", valueChangeEvent="input", stylingMode="filled")
					.flex-col.flex-1
						.font-tiny.upper.grey {{$tCaption('AI Prompt')}}
						DxSelectBox(:value.sync="prompt", :data-source="prompts", display-expr="Name", value-expr="Oid", :dropDownOptions="{ width: '320px' }", stylingMode="filled")
				.flex-row.space
					DxCheckBox(:text="$tCaption('Save Logs')", :value.sync="stylizerBO.SaveLogs")
			.flex-col.space
				.flex-row.space
					.upper.grey.flex-row.align-center.space
						span {{$tCaption('Tags')}}
						span(v-if="tags.length") ({{tags.length}})
					DxButton(icon="plus", :hint="$tCaption('Add tag')", @click="addTag", stylingMode="text")
				DxScrollView(showScrollbar="always", :height="260", width="100%", ref="scroll")
					.flex-col.space
						.flex-col.space.ssml-tag(v-for="tag in tags")
							.flex-row.space
								.flex-col.flex-1
									.font-small.upper.grey {{$tCaption('Name')}}
									DxTextBox(:value.sync="tag.Name", stylingMode="filled")
								.flex-col.flex-1
									.font-small.upper.grey {{$tCaption('Type')}}
									DxSelectBox(:data-source="tagTypes", :value.sync="tag.TagType", valueExpr="id", displayExpr="name", stylingMode="filled")
								.flex-col.flex-3
									.font-small.upper.grey {{$tCaption('Template')}}
									DxTextBox(:value.sync="tag.Template", stylingMode="filled", :placeholder="$tCaption('Example: \<prosody pitch=\"+RANDOM[1,4]%\"\>@text\<\/prosody\>')")
</template>

<script>
	import _ from 'lodash';
	import Loader from 'app-core/Loader.vue';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxScrollView from 'devextreme-vue/scroll-view';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxButton from 'devextreme-vue/button';
	import { SSML_STYLIZER_TAG_TYPES } from 'app-core/constants';
	import DxCheckBox from 'devextreme-vue/check-box';

	export default {
		translationCategory: 'stylizer.Detail',
		name: 'stylizer--detail',
		props: ['stylizerBO'],
		components: { DxTextBox, Loader, DxScrollView, DxSelectBox, DxButton, DxCheckBox },
		data() {
			return {
				isLoading: false,
				prompts: [],
				tags: [],
				tagTypes: SSML_STYLIZER_TAG_TYPES.toLocale('name', this)
			};
		},
		computed: {
			prompt: {
				get: function() { return this.stylizerBO?.AiPrompt?.Oid; },
				set: function(v) {
					this.$set(this.stylizerBO, 'AiPrompt', { Oid: v });
				}
			}
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.stylizerDetail = this;
			this.loadPrompts();
			this.loadTags();
		},
		methods: {
			addTag() {
				this.tags.push({
					TagType: 0,
					Template: '@text',
					Stylizer: {
						Oid: this.stylizerBO?.Oid
					},
					Name: '',
					Oid: null
				});
			},
			async loadPrompts() {
				this.isLoading++;
				this.prompts = (await this.$Data.getExternalApi('AIScriptGenerator/List', `filterCriteria=['UseType', '=', 3]&privateFilter=0`).finally(() => this.isLoading--))?.Results || [];
				if (!this.stylizerBO.AiPrompt?.Oid) {
					this.stylizerBO.AiPrompt.Oid = this.prompts[0]?.Oid;
				}
			},
			async loadTags() {
				this.isLoading++;
				this.tags = (await this.$Data.getExternalApi('SsmlStylizerTag/List', `stylizerOid=${this.stylizerBO.Oid}`).finally(() => this.isLoading--))?.Results || [];
			},
			async save() {
				_.assign(this.stylizerBO, (await this.$Data.postExternalApi('SsmlStylizer/CreateUpdate', this.stylizerBO))?.Data);

				if (this.tags.length) {
					await Promise.all(this.tags.map(f => {
						f.Stylizer.Oid = this.stylizerBO.Oid;
						return this.$Data.postExternalApi('SsmlStylizerTag/CreateUpdate', f).then(r => _.assign(f, r?.Data || f));
					}));
				}
			},
			checkRequired() {
				let notExistsTags = this.tagTypes.filter(f => !this.tags.some(t => t.TagType === f.id));
				if (notExistsTags.length) {
					this.$notifyError(this.$tCaption('At least one tag of this type should be added to tags list: __TAGS__').replace(/__TAGS__/g, notExistsTags.map(f => f.name).join(', ')));
					return false;
				}
				return true;
			}
		}
	};
</script>
<style lang='scss'>
	.stylizer--detail {
		
	}
</style>
